import React from "react";
import moment from "moment";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { MyTimeDateHeaderTooltip } from "my-time/components";

interface MyTimeCalendarWeeklyDayHeaderProps {
  date: string | Date;
  isOffRange: boolean;
  countTimeData: (date: string | Date) => {
    workTime: number;
    overtime: number;
    voluntaryOvertime: number;
  };
}

export const MyTimeCalendarWeeklyDayHeader = (
  props: MyTimeCalendarWeeklyDayHeaderProps,
) => {
  const { date, isOffRange, countTimeData } = props;
  const dayName = moment(date).format("dddd");
  const dayNumber = moment(date).format("D");
  const theme = useTheme();

  const { workTime, overtime, voluntaryOvertime } = countTimeData(date);

  return (
    <MyTimeDateHeaderTooltip
      workTime={workTime}
      overtime={overtime}
      voluntaryOvertime={voluntaryOvertime}
      isOffRange={isOffRange}
      date={date}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="48px"
        padding="8px 0px"
        fontWeight={400}
      >
        <Typography
          variant="body1"
          color={theme.palette.gray80.main}
          style={{ padding: 0, margin: 0, lineHeight: "16px" }}
        >
          {dayName}
        </Typography>
        <Typography
          variant="body1"
          color={theme.palette.gray80.main}
          style={{ padding: 0, margin: 0, lineHeight: "16px" }}
        >
          {dayNumber}
        </Typography>
      </Box>
    </MyTimeDateHeaderTooltip>
  );
};

export default MyTimeCalendarWeeklyDayHeader;
